export default __webpack_public_path__ + "static/fin-port-const-sol-72f994a65e48a4fa5af651af68cb4607.png";